export default {
    User: {
        Password: {
            IsRequired: "Пароль обов'язковий",
            MustBeGreaterThen3: "Мінімальна довжина пароля 4 символи",
            PasswordsNotMatch: "Паролі не співпадають"
        }
    }

}